import API from "@/api";

const SET_ADDRESSES = "SET_ADDRESSES";
const SET_PRELOADER = "SET_PRELOADER";

const defaultState = () => {
  return {
    addresses: null,
    preloader: false
  };
};

const actions = {
  async getAddresses({ commit, dispatch }) {
    commit(SET_PRELOADER, true);

    try {
      const addresses = await API.Addresses.index(1);
      commit(SET_ADDRESSES, addresses);
    } catch (e) {
      dispatch(
        "toast/setToast",
        {
          message:
            "Não foi possível buscar os seus endereços. Atualize a página!",
          type: "error"
        },
        { root: true }
      );
    }

    commit(SET_PRELOADER, false);
  },

  async create({ dispatch }, payload) {
    try {
      await API.Addresses.create(payload);

      await dispatch("getAddresses");

      dispatch(
        "toast/setToast",
        {
          message: "Endereço criado com sucesso!",
          type: "success"
        },
        { root: true }
      );
    } catch (e) {
      dispatch(
        "toast/setToast",
        {
          message: "Ocorreu um erro na criação do endereço. Tente novamente!",
          type: "error"
        },
        { root: true }
      );
    }
  },

  async update({ dispatch }, payload) {
    try {
      await API.Addresses.update(payload);

      await dispatch("getAddresses");

      dispatch(
        "toast/setToast",
        {
          message: "Endereço alterado com sucesso!",
          type: "success"
        },
        { root: true }
      );
    } catch (e) {
      dispatch(
        "toast/setToast",
        {
          message:
            "Não foi possível atualizar o seu endereço. Tente novamente!",
          type: "error"
        },
        { root: true }
      );
    }
  }
};

const mutations = {
  [SET_ADDRESSES](state, addresses) {
    state.addresses = addresses;
  },

  [SET_PRELOADER](state, loading) {
    state.preloader = loading;
  }
};

export default {
  namespaced: true,
  state: defaultState(),
  actions: actions,
  mutations: mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js